import create from 'zustand';
import { TraceStoreProps } from './typings';

const useTraceStore = create<TraceStoreProps>((set) => ({
  traceTab: 'map',
  setTraceTab: (traceTab: string) =>
    set(() => ({
      traceTab,
    })),
  selectedLotData: {},
  setSelectedLotData: (selectedLotData) =>
    set(() => ({
      selectedLotData,
    })),
  selectedMarker: {
    id: '',
    position: {
      lat: 0,
      lng: 0,
    },
  },
  setSelectedMarker: (selectedMarker) => set(() => ({ selectedMarker })),
  selectedNode: {
    id: '',
    colourIndex: '',
    eventType: '',
    eventTime: '',
    eventTimezoneOffset: '',
    customProperties: [],
    created: '',
    creator: '',
    businessStep: '',
    disposition: '',
    location: {
      id: '',
      name: '',
      facilityType: '',
      accountID: '',
      accountName: '',
      urN: '',
      geoCoordinates: {
        latitude: 0,
        longitude: 0,
      },
      address: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
      },
    },
    products: [
      {
        id: '',
        urN: '',
        productIdentifierType: '',
        productID: '',
        accountID: '',
        accountName: '',
        name: '',
        species: '',
        unitOfMeasure: '',
        quantity: '',
        customAttributes: [],
      },
    ],
  },
  setSelectedNode: (selectedNode) => set(() => ({ selectedNode })),
  markerModalVisible: false,
  setMarkerModalVisible: (markerModalVisible) => set(() => ({ markerModalVisible })),
  selectedLot: [],
  setSelectedLot: (selectedLot) =>
    set(() => ({
      selectedLot,
    })),
  selectedActiveEvent: 0,
  setSelectedActiveEvent: (selectedActiveEvent) =>
    set(() => ({
      selectedActiveEvent,
    })),
}));

export default useTraceStore;
